import { Stack } from "@atlaskit/primitives-next";
import { Card } from "@atlaskit/smart-card";

import { useFastshiftSelector } from "@/components/fastshift/src/state/hook";

export const ConfluenceCardLinkSection = () => {
    const { data: engagementData } = useFastshiftSelector(
        (state) => state.customerDomainEngagement
    );

    if (engagementData?.engagementSpaces.length === 0) {
        return null;
    }

    return (
        <Stack>
            {engagementData?.engagementSpaces.map((space) => (
                <Card
                    key={space.spaceKey}
                    url={space.spaceUrl}
                    appearance="block"
                />
            ))}
        </Stack>
    );
};
